import { Divider, Grid, IconButton, Stack, Typography } from '@mui/material';
import React from 'react';
import { CloseWithoutBorder } from '../../../assets/images';
var PartInfo = function (_ref) {
    var _data$ProductName, _data$Code, _data$DefaultInventor, _data$HSNCode, _data$PriceDetail$Pri, _data$PriceDetail;
    var onClose = _ref.onClose, data = _ref.data;
    return /*#__PURE__*/ React.createElement(Grid, null, /*#__PURE__*/ React.createElement(Stack, {
        direction: "row",
        justifyContent: "space-between",
        alignItems: "center",
        bgcolor: "secondary.50",
        p: 2
    }, /*#__PURE__*/ React.createElement(Stack, null, /*#__PURE__*/ React.createElement(Typography, {
        fontWeight: 'medium',
        fontSize: "base",
        color: "secondary.dark"
    }, (_data$ProductName = data === null || data === void 0 ? void 0 : data.ProductName) !== null && _data$ProductName !== void 0 ? _data$ProductName : "-"), /*#__PURE__*/ React.createElement(Typography, {
        fontWeight: 'normal',
        fontSize: "sm",
        color: "secondary.600"
    }, (_data$Code = data === null || data === void 0 ? void 0 : data.Code) !== null && _data$Code !== void 0 ? _data$Code : "-")), /*#__PURE__*/ React.createElement(IconButton, {
        onClick: function () { return onClose(); }
    }, /*#__PURE__*/ React.createElement("img", {
        src: CloseWithoutBorder
    }))), /*#__PURE__*/ React.createElement(Stack, {
        p: 2,
        spacing: 2
    }, /*#__PURE__*/ React.createElement(Stack, {
        direction: "row",
        justifyContent: "space-between"
    }, /*#__PURE__*/ React.createElement(Stack, null, /*#__PURE__*/ React.createElement(Typography, {
        fontSize: "sm",
        fontWeight: 'medium',
        color: "secondary.main"
    }, "Part type"), /*#__PURE__*/ React.createElement(Typography, {
        fontWeight: 'medium',
        fontSize: "base",
        color: "secondary.dark"
    }, (_data$DefaultInventor = data === null || data === void 0 ? void 0 : data.DefaultInventoryTrackingType) !== null && _data$DefaultInventor !== void 0 ? _data$DefaultInventor : "-")), /*#__PURE__*/ React.createElement(Stack, null, /*#__PURE__*/ React.createElement(Typography, {
        fontSize: "sm",
        fontWeight: 'medium',
        color: "secondary.main"
    }, "HSN Code"), /*#__PURE__*/ React.createElement(Typography, {
        fontWeight: 'medium',
        fontSize: "base",
        color: "secondary.dark"
    }, (_data$HSNCode = data === null || data === void 0 ? void 0 : data.HSNCode) !== null && _data$HSNCode !== void 0 ? _data$HSNCode : "-"))), /*#__PURE__*/ React.createElement(Divider, null), /*#__PURE__*/ React.createElement(Stack, null, /*#__PURE__*/ React.createElement(Typography, {
        fontSize: "sm",
        fontWeight: 'medium',
        color: "secondary.main"
    }, "Cost (\u20B9)"), /*#__PURE__*/ React.createElement(Typography, {
        fontWeight: 'medium',
        fontSize: "base",
        color: "secondary.dark"
    }, (_data$PriceDetail$Pri = data === null || data === void 0 || (_data$PriceDetail = data.PriceDetail) === null || _data$PriceDetail === void 0 ? void 0 : _data$PriceDetail.Price) !== null && _data$PriceDetail$Pri !== void 0 ? _data$PriceDetail$Pri : "-"))));
};
export default PartInfo;
